import { all, fork } from 'redux-saga/effects';

import appSagas from './app';
import attendanceSaga from './attendance';
import callMeSagas from './callMe';
import cartSagas from './cart';
import categorySagas from './category';
import checkoutSagas from './checkout';
import contactSagas from './contact';
import creditCardSagas from './creditCard';
import customerSagas from './customer';
import deliverySagas from './delivery';
import freightsSagas from './freights';
import landingpageSagas from './landingpage';
import localizationSagas from './localization';
import productSagas from './product';
import publicationsSagas from './publications';
import recommendationsSagas from './recommendations';
import searchSagas from './search';
import siteMapSagas from './sitemap';
import storesSagas from './stores';
import totemSagas from './totem';
import whatsAppSagas from './whatsApp';

function* rootSaga() {
  yield all([
    fork(appSagas),
    fork(cartSagas),
    fork(totemSagas),
    fork(storesSagas),
    fork(searchSagas),
    fork(callMeSagas),
    fork(productSagas),
    fork(contactSagas),
    fork(siteMapSagas),
    fork(categorySagas),
    fork(freightsSagas),
    fork(customerSagas),
    fork(deliverySagas),
    fork(checkoutSagas),
    fork(whatsAppSagas),
    fork(attendanceSaga),
    fork(creditCardSagas),
    fork(landingpageSagas),
    fork(localizationSagas),
    fork(publicationsSagas),
    fork(recommendationsSagas),
  ]);
}

export default rootSaga;
